import { createSlice } from "@reduxjs/toolkit";
import {
  clearStoredTeacherAuth,
  clearStoredTeacherSignupContext,
  getStoredTeacherAuth,
  getStoredTeacherSignupContext,
  persistTeacherAuth,
  persistTeacherSignupContext,
} from "./teacherStorage";

const initialAuth = getStoredTeacherAuth();
const initialSignupContext = getStoredTeacherSignupContext();

const initialState = {
  token: initialAuth.token,
  teacher: initialAuth.teacher,
  signupContext: initialSignupContext,
};

const teacherSlice = createSlice({
  name: "teacher",
  initialState,
  reducers: {
    setTeacherSession(state, action) {
      const nextAuth = persistTeacherAuth({
        token: action.payload?.token,
        teacher: action.payload?.teacher,
      });

      state.token = nextAuth.token;
      state.teacher = nextAuth.teacher;
    },
    updateTeacherProfile(state, action) {
      const nextTeacher =
        action.payload && typeof action.payload === "object"
          ? { ...(state.teacher || {}), ...action.payload }
          : state.teacher;

      const nextAuth = persistTeacherAuth({
        token: state.token,
        teacher: nextTeacher,
      });

      state.teacher = nextAuth.teacher;
    },
    clearTeacherSession(state) {
      clearStoredTeacherAuth();
      state.token = "";
      state.teacher = null;
    },
    setTeacherSignupContext(state, action) {
      const nextContext = persistTeacherSignupContext({
        preAuthToken: action.payload?.preAuthToken,
        email: action.payload?.email,
      });

      state.signupContext = nextContext;
    },
    clearTeacherSignupContext(state) {
      clearStoredTeacherSignupContext();
      state.signupContext = {
        preAuthToken: "",
        email: "",
      };
    },
  },
});

export const {
  setTeacherSession,
  updateTeacherProfile,
  clearTeacherSession,
  setTeacherSignupContext,
  clearTeacherSignupContext,
} = teacherSlice.actions;

export default teacherSlice.reducer;
